import { AssetType, WebSourceAsset } from "../../redux/assets-slice";

export const isModelFile = (asset) => {
  return (asset.type === AssetType.IFC)
    || (asset.type === AssetType.DXF)
    || (asset.type === AssetType.SHP);
};

export const isStreamablePointsFile = (asset) => {
  return (asset.type === AssetType.Encompass)
    || (asset.type === AssetType.Potree);
};

export const isRawPointsFile = (asset) => {
  return (asset.type === AssetType.LAS)
    || (asset.type === AssetType.E57Points);
};

export const getModelLayers = (asset) => {
  return asset.data.map(layer => ({
    name: layer.name,
    originalId: layer.id,
    visible: layer.visible,
    color: layer.color
  }));
};

export const getWebmapLayers = (asset: WebSourceAsset) => {
  return asset.data.layers.map(layer => ({
    originalId: layer.id,
    visible: layer.visible,
    identifier: String(layer.identifier),
    name: String(layer.name)
  }));
};

export const getBaseAsset = (asset) => {
  return {
    name: asset.name,
    visible: asset.visible,
    originalId: asset.id,
    type: asset.type,
  };
};

export const getTagsData = (asset) => {
  return asset.data.items.map(tag => {
    const values = {
      originalId: tag.id,
      name: tag.name,
      comment: tag.comment,
      date: tag.date,
      x: tag.x,
      y: tag.y,
    } as any;

    if ("z" in tag) {
      values.z = tag.z;
    }

    if ("sceneState" in tag) {
      values.sceneState = tag.sceneState;
    }

    return values;
  });
};

export const getImageData = (asset) => {
  return asset.data.map(image => {
    const values = {
      originalId: image.id,
      filename: image.name,
      x: image.x,
      y: image.y,
      z: image.z,
      roll: image.roll,
      pitch: image.pitch,
      yaw: image.yaw
    };

    /** Planar images have additional information */
    if (asset.type === AssetType.Planar) {
      return {
        ...values,
        config: image.config
      };
    }

    return values;
  });
};

interface ObjectProps {
  id: string;
  [key: string]: any;
}

export const withOriginalID = (object: ObjectProps) => {
  const {id, ...other} = object;
  return {originalId: id, ...other};
};